import { TriangleAlert } from "lucide-react";
import { useTranslate } from "ra-core";
import { Badge } from "@/components/ui/badge";

import type { Contact } from "../types";
import { CONTACT_TYPE_LABEL_KEYS } from "./contactTypes";

/**
 * Almikia Epic EC2a: the contact type chips of a list row (a legacy contact with no type shows
 * none). The label comes from the same i18n keys as the form.
 */
export const ContactTypeChips = ({
  contact,
}: {
  contact: Pick<Contact, "contact_types">;
}) => {
  const translate = useTranslate();
  const types = contact.contact_types ?? [];
  if (types.length === 0) return null;
  return (
    <span className="inline-flex flex-wrap gap-1 align-middle">
      {types.map((type) => (
        <Badge
          key={type}
          variant="secondary"
          className="text-xs font-normal"
          data-testid="contact-type-chip"
        >
          {translate(CONTACT_TYPE_LABEL_KEYS[type] ?? type, { _: type })}
        </Badge>
      ))}
    </span>
  );
};

/** Read-only "Revisar nombre" badge of a list row (the one-tap fix lives on the contact page). */
export const ContactNameReviewBadge = ({
  contact,
}: {
  contact: Pick<Contact, "name_needs_review">;
}) => {
  const translate = useTranslate();
  if (!contact.name_needs_review) return null;
  return (
    <Badge
      variant="outline"
      className="gap-1 text-xs text-brand-red-text bg-brand-red-bg border-transparent"
    >
      <TriangleAlert className="size-3" aria-hidden="true" />
      {translate("resources.contacts.name_review.badge")}
    </Badge>
  );
};
